module.exports = __webpack_public_path__ + "images/feature/20160901_03-737dc3adbba0a2b51fd88a742bbf2266.png";